import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";

const stats = [
  { label: "Members", value: 420 },
  { label: "Projects", value: 22 },
];

const allProjects = [
  // Requests
  {
    title: "Looking for 200Ah/220Ah Battery",
    type: "Request",
    location: "Lagos",
    status: "Open",
    price: "₦85,000",
    description: "Need a fairly used 200Ah or 220Ah battery for home backup.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",

    user: { name: "Pascal Daniel", reputation: null },
  },
  {
    title: "Need Solar Freezer",
    type: "Request",
    location: "Abuja",
    status: "Open",
    price: "₦150,000 budget",
    description: "Looking for a solar freezer for small business use.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=600&q=80",
    user: { name: "Nneka Nwangugu", reputation: null },
  },
  {
    title: "Seeking Installer for 5kVA System",
    type: "Request",
    location: "Port Harcourt",
    status: "Open",
    price: "₦1,000,000 budget",
    description: "Need a certified installer for a 5kVA solar system at my residence.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",
    user: { name: "John Doe", reputation: { rating: 4.5, reviews: 10 } },
  },
  {
    title: "Need MPPT Charge Controller",
    type: "Request",
    location: "Enugu",
    status: "Open",
    price: "₦60,000 budget",
    description: "Looking for a reliable MPPT charge controller for 48V system.",
    image: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80",
    user: { name: "Jane Smith", reputation: { rating: 4.9, reviews: 25 } },
  },
  {
    title: "Looking for 1.5kVA Inverter",
    type: "Request",
    location: "Ibadan",
    status: "Open",
    price: "₦70,000 budget",
    description: "Need a 1.5kVA inverter, new or used, for home use.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",
    user: { name: "Peter Parker", reputation: { rating: 4.2, reviews: 8 } },
  },
  {
    title: "Need Solar Panel Installation",
    type: "Request",
    location: "Benin City",
    status: "Open",
    price: "₦500,000 budget",
    description: "Looking for a professional to install 8x 450W panels.",
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80",
    user: { name: "Sarah Johnson", reputation: { rating: 4.7, reviews: 15 } },
  },
  {
    title: "Request for Solar Street Light",
    type: "Request",
    location: "Kano",
    status: "Open",
    price: "₦80,000 budget",
    description: "Need 200W solar street light for community project.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",
    user: { name: "Mike Wilson", reputation: { rating: 4.0, reviews: 5 } },
  },
  {
    title: "Looking for Solar Freezer Power Pack",
    type: "Request",
    location: "Onitsha",
    status: "Open",
    price: "₦40,000 budget",
    description: "Need a power pack for solar freezer, 12V preferred.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=600&q=80",
    user: { name: "Lisa Brown", reputation: { rating: 4.8, reviews: 20 } },
  },
  {
    title: "Request for 2.4kVA Mercury Inverter",
    type: "Request",
    location: "Abuja",
    status: "Open",
    price: "₦120,000 budget",
    description: "Looking for 2.4kVA Mercury transformerless inverter.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",
    user: { name: "David Lee", reputation: { rating: 4.6, reviews: 12 } },
  },
  {
    title: "Need Solar System Maintenance",
    type: "Request",
    location: "Abeokuta",
    status: "Open",
    price: "₦30,000 budget",
    description: "Looking for a technician to service 3kVA solar system.",
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80",
    user: { name: "Emma Davis", reputation: { rating: 4.9, reviews: 30 } },
  },
  // Offers
  {
    title: "Solar Street Light 200W Available",
    type: "Offer",
    location: "Kano",
    status: "Open",
    price: "₦75,000",
    description: "Brand new 200W solar street lights, bulk purchase available.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",
    user: { name: "EL-Tayib Energy Systems", reputation: { rating: 4.8, reviews: 32 } },
  },
  {
    title: "10kVA Solar System for Sale",
    type: "Offer",
    location: "Lagos",
    status: "Open",
    price: "₦2,500,000",
    description: "Complete 10kVA solar system, 48V, 20x 450W panels, installation included.",
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80",
    user: { name: "GodfreyworldsolarGlobal LTD Nig", reputation: { rating: 4.7, reviews: 54 } },
  },
  {
    title: "2.4kVA Mercury Inverter",
    type: "Offer",
    location: "Abuja",
    status: "Open",
    price: "₦110,000",
    description: "Brand new Mercury 2.4kVA inverter, transformerless, 24V.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",
    user: { name: "SolarPro Solutions", reputation: { rating: 4.9, reviews: 40 } },
  },
  {
    title: "450W Solar Panels Nationwide",
    type: "Offer",
    location: "Nationwide",
    status: "Open",
    price: "₦95,000",
    description: "High-efficiency 450W solar panels, delivery nationwide.",
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80",
    user: { name: "Renewable Energy Co.", reputation: { rating: 4.6, reviews: 20 } },
  },
  {
    title: "Used 200Ah Battery, Alaba Market",
    type: "Offer",
    location: "Lagos",
    status: "Open",
    price: "₦60,000",
    description: "Fairly used 200Ah battery, tested and guaranteed.",
    image: "https://images.unsplash.com/photo-1609592806598-ef9b1edb8c8b?auto=format&fit=crop&w=600&q=80",
    user: { name: "Battery Depot", reputation: { rating: 4.9, reviews: 10 } },
  },
  {
    title: "Solar Freezer for Sale",
    type: "Offer",
    location: "Abuja",
    status: "Open",
    price: "₦140,000",
    description: "Energy-efficient solar freezer, 150L, 12/24V compatible.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=600&q=80",
    user: { name: "FreezerPro", reputation: { rating: 4.8, reviews: 25 } },
  },
  {
    title: "MPPT Charge Controller 60A",
    type: "Offer",
    location: "Enugu",
    status: "Open",
    price: "₦55,000",
    description: "MPPT charge controller, 60A, 12/24/48V, warranty included.",
    image: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80",
    user: { name: "ChargeMaster", reputation: { rating: 4.7, reviews: 18 } },
  },
  {
    title: "Solar System Installation Service",
    type: "Offer",
    location: "Port Harcourt",
    status: "Open",
    price: "₦80,000",
    description: "Professional installation for up to 5kVA systems.",
    image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=600&q=80",
    user: { name: "InstallPro", reputation: { rating: 4.9, reviews: 35 } },
  },
  {
    title: "Solar Power Pack for Freezer",
    type: "Offer",
    location: "Onitsha",
    status: "Open",
    price: "₦38,000",
    description: "12V/24V power pack for solar freezers, plug and play.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=600&q=80",
    user: { name: "PowerPack Solutions", reputation: { rating: 4.8, reviews: 20 } },
  },
  {
    title: "Solar System Maintenance Service",
    type: "Offer",
    location: "Abeokuta",
    status: "Open",
    price: "₦25,000",
    description: "Routine maintenance for solar systems up to 10kVA.",
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80",
    user: { name: "ServiceMaster", reputation: { rating: 4.7, reviews: 15 } },
  },
  // Closed/Completed
  {
    title: "Plug & Play Solar",
    type: "Offer",
    location: "Bay Area, CA",
    status: "Closed",
    price: "₦124,000",
    description: "Plug & Play solar kit, fully funded and closed for new investments.",
    image: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80",
    user: { name: "Plug & Play Solar Team", reputation: { rating: 4.9, reviews: 18 } },
  },
  {
    title: "Millstone Community Solar",
    type: "Offer",
    location: "New Jersey",
    status: "Closed",
    price: "₦737,500",
    description: "Community solar project, fully funded and closed.",
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80",
    user: { name: "Community Solar Co.", reputation: { rating: 4.9, reviews: 20 } },
  },
];

const typeOptions = ["Request", "Offer"];

const contactLinks = [
  {
    label: "Gmail",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-.904.732-1.636 1.636-1.636h.409L12 10.09l10.955-6.269h.409A1.636 1.636 0 0 1 24 5.457z"/>
      </svg>
    ),
    getHref: (project, contactInfo) => {
      const email = project.type === 'Request' ? contactInfo?.email : 'info@abiu.earth';
      return `mailto:${email}?subject=Regarding: ${encodeURIComponent(project.title)}`;
    },
  },
  {
    label: "WhatsApp",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
      </svg>
    ),
    getHref: (project, contactInfo) => {
      const phone = project.type === 'Request' ? contactInfo?.phone : '2347012345678';
      return `https://wa.me/${phone}?text=I'm%20interested%20in%20${encodeURIComponent(project.title)}`;
    },
  },
  {
    label: "Instagram",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    getHref: (project, contactInfo) => {
      const instagram = project.type === 'Request' ? contactInfo?.instagram : 'abiu.earth';
      return `https://instagram.com/${instagram}`;
    },
  },
];

const StarRating = ({ rating, reviews }) => (
  <div className="flex items-center gap-1 text-yellow-500 text-sm">
    <span>{'★'.repeat(Math.round(rating))}{'☆'.repeat(5 - Math.round(rating))}</span>
    <span className="text-gray-600 ml-1">{rating.toFixed(1)} ({reviews})</span>
  </div>
);

const Marketplace = () => {
  const [search, setSearch] = useState("");
  const [type, setType] = useState("Offer");
  const [modal, setModal] = useState(null); // null | { type: 'details'|'contact', project: ... }
  const [showFilters, setShowFilters] = useState(false);
  const [offers, setOffers] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buyerProfile, setBuyerProfile] = useState(null);
  const [sellerProfile, setSellerProfile] = useState(null);
  const [filters, setFilters] = useState({
    category: 'all',
    location: '',
    selectedLocations: [],
    minPrice: '',
    maxPrice: '',
    status: ['open']
  });
  const { userProfile } = useAuth();

  // Load offers and requests from Firebase
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        
        // Load offers
        const offersQuery = query(collection(db, 'offers'), where('status', '==', 'Open'));
        const offersSnapshot = await getDocs(offersQuery);
        const offersData = offersSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setOffers(offersData);
        
        // Load requests
        const requestsQuery = query(collection(db, 'requests'), where('status', '==', 'Open'));
        const requestsSnapshot = await getDocs(requestsQuery);
        const requestsData = requestsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setRequests(requestsData);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const filtered = (() => {
    let data = type === 'Offer' ? offers : type === 'Request' ? requests : allProjects;
    
    return data.filter((p) => {
      // Search filter
      const matchesSearch =
        p.title.toLowerCase().includes(search.toLowerCase()) ||
        p.location.toLowerCase().includes(search.toLowerCase()) ||
        p.description.toLowerCase().includes(search.toLowerCase());
      
      if (!matchesSearch) return false;
      
      // Category filter
      if (filters.category !== 'all') {
        if (filters.category === 'requests' && p.type !== 'Request') return false;
        if (filters.category === 'offers' && p.type !== 'Offer') return false;
      }
      
      // Location filter
      if (filters.location && !p.location.toLowerCase().includes(filters.location.toLowerCase())) {
        return false;
      }
      
      // Selected locations filter
      if (filters.selectedLocations.length > 0 && !filters.selectedLocations.includes(p.location)) {
        return false;
      }
      
      // Price range filter
      if (filters.minPrice || filters.maxPrice) {
        const price = p.type === 'Request' ? parseInt(p.budget) : parseInt(p.price);
        if (filters.minPrice && price < parseInt(filters.minPrice)) return false;
        if (filters.maxPrice && price > parseInt(filters.maxPrice)) return false;
      }
      
      // Status filter
      if (filters.status.length > 0) {
        const projectStatus = p.status.toLowerCase();
        if (!filters.status.includes(projectStatus)) return false;
      }
      
      return true;
    });
  })();

  const openModal = async (type, project) => {
    setModal({ type, project });
    
    // If it's a request, fetch the buyer's profile
    if (project.type === 'Request' && project.buyerId) {
      try {
        const buyerDoc = await getDoc(doc(db, 'users', project.buyerId));
        if (buyerDoc.exists()) {
          setBuyerProfile(buyerDoc.data());
        }
      } catch (error) {
        console.error('Error fetching buyer profile:', error);
      }
    } else {
      setBuyerProfile(null)
    }
    
    // If it's an offer, fetch the seller's profile
    if (project.type === 'Offer' && project.sellerId) {
      try {
        const sellerDoc = await getDoc(doc(db, 'users', project.sellerId));
        if (sellerDoc.exists()) {
          setSellerProfile(sellerDoc.data());
        }
      } catch (error) {
        console.error('Error fetching seller profile:', error);
      }
    } else {
      setSellerProfile(null);
    }
  };
  
  const closeModal = () => {
    setModal(null);
    setBuyerProfile(null);
    setSellerProfile(null);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const handleLocationToggle = (location) => {
    setFilters(prev => ({
      ...prev,
      selectedLocations: prev.selectedLocations.includes(location)
        ? prev.selectedLocations.filter(loc => loc !== location)
        : [...prev.selectedLocations, location]
    }));
  };

  const handleStatusToggle = (status) => {
    setFilters(prev => ({
      ...prev,
      status: prev.status.includes(status)
        ? prev.status.filter(s => s !== status)
        : [...prev.status, status]
    }));
  };

  const clearFilters = () => {
    setFilters({
      category: 'all',
      location: '',
      selectedLocations: [],
      minPrice: '',
      maxPrice: '',
      status: ['open']
    });
  };

  return (
    <div className="bg-abiu-green-bg min-h-screen">
      <div className="flex flex-col lg:flex-row">
        {/* Left Sidebar - Filters */}
        <div className={`w-full lg:w-1/5 bg-white shadow-lg ${showFilters ? 'min-h-screen' : 'h-auto'} lg:min-h-screen p-4 lg:p-6`}>
          {/* Mobile Filter Toggle */}
          <div className="lg:hidden mb-4">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="w-full bg-abiu-green text-white py-2 px-4 rounded-lg font-medium flex items-center justify-between"
            >
              <span>Filters</span>
              <svg className={`w-5 h-5 transition-transform ${showFilters ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
          
          {/* Filter Content */}
          <div className={`lg:block ${showFilters ? 'block' : 'hidden'}`}>
            <h2 className="text-lg lg:text-xl font-bold text-abiu-green-dark mb-4 lg:mb-6">Filters</h2>
          
          {/* Category Filter */}
          <div className="mb-6 lg:mb-8">
            <h3 className="font-bold text-gray-800 mb-2 lg:mb-3 text-sm lg:text-base">CATEGORY</h3>
            <div className="space-y-2">
              <div className="flex items-center">
                <input 
                  type="radio" 
                  id="all" 
                  name="category" 
                  className="mr-2" 
                  checked={filters.category === 'all'}
                  onChange={() => handleFilterChange('category', 'all')}
                />
                <label htmlFor="all" className="text-sm text-gray-700">All Projects</label>
              </div>
              <div className="flex items-center">
                <input 
                  type="radio" 
                  id="requests" 
                  name="category" 
                  className="mr-2" 
                  checked={filters.category === 'requests'}
                  onChange={() => handleFilterChange('category', 'requests')}
                />
                <label htmlFor="requests" className="text-sm text-gray-700">Requests</label>
              </div>
              <div className="flex items-center">
                <input 
                  type="radio" 
                  id="offers" 
                  name="category" 
                  className="mr-2" 
                  checked={filters.category === 'offers'}
                  onChange={() => handleFilterChange('category', 'offers')}
                />
                <label htmlFor="offers" className="text-sm text-gray-700">Offers</label>
              </div>
            </div>
          </div>

          {/* Location Filter */}
          <div className="mb-6 lg:mb-8">
            <h3 className="font-bold text-gray-800 mb-2 lg:mb-3 text-sm lg:text-base">LOCATION</h3>
            <input
              type="text"
              placeholder="Search location..."
              value={filters.location}
              onChange={(e) => handleFilterChange('location', e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
            />
            <div className="mt-3 space-y-2">
              {['Lagos', 'Abuja', 'Port Harcourt', 'Enugu', 'Ibadan', 'Kano'].map(location => (
                <div key={location} className="flex items-center">
                  <input 
                    type="checkbox" 
                    id={location} 
                    className="mr-2" 
                    checked={filters.selectedLocations.includes(location)}
                    onChange={() => handleLocationToggle(location)}
                  />
                  <label htmlFor={location} className="text-sm text-gray-700">{location}</label>
                </div>
              ))}
            </div>
          </div>

          {/* Price Range Filter */}
          <div className="mb-6 lg:mb-8">
            <h3 className="font-bold text-gray-800 mb-2 lg:mb-3 text-sm lg:text-base">PRICE (₦)</h3>
            <div className="flex gap-2 mb-3">
              <input
                type="number"
                placeholder="Min"
                value={filters.minPrice}
                onChange={(e) => handleFilterChange('minPrice', e.target.value)}
                className="w-1/2 px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
              <input
                type="number"
                placeholder="Max"
                value={filters.maxPrice}
                onChange={(e) => handleFilterChange('maxPrice', e.target.value)}
                className="w-1/2 px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
            <button 
              onClick={clearFilters}
              className="w-full bg-gray-200 text-gray-700 py-2 rounded-lg text-sm font-medium hover:bg-gray-300 transition"
            >
              Clear Filters
            </button>
          </div>

          {/* Status Filter */}
          <div className="mb-6 lg:mb-8">
            <h3 className="font-bold text-gray-800 mb-2 lg:mb-3 text-sm lg:text-base">STATUS</h3>
            <div className="space-y-2">
              <div className="flex items-center">
                <input 
                  type="checkbox" 
                  id="open" 
                  className="mr-2" 
                  checked={filters.status.includes('open')}
                  onChange={() => handleStatusToggle('open')}
                />
                <label htmlFor="open" className="text-sm text-gray-700">Open</label>
              </div>
              <div className="flex items-center">
                <input 
                  type="checkbox" 
                  id="closed" 
                  className="mr-2" 
                  checked={filters.status.includes('closed')}
                  onChange={() => handleStatusToggle('closed')}
                />
                <label htmlFor="closed" className="text-sm text-gray-700">Closed</label>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="border-t pt-4 lg:pt-6">
            <h3 className="font-bold text-gray-800 mb-2 lg:mb-3 text-sm lg:text-base">STATISTICS</h3>
            <div className="space-y-3">
              {stats.map((s) => (
                <div key={s.label} className="bg-abiu-green-light/20 rounded-lg p-3">
                  <div className="text-sm text-gray-600">{s.label}</div>
                  <div className="text-lg font-bold text-abiu-green-dark">{s.value.toLocaleString()}</div>
                </div>
              ))}
            </div>
          </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 p-4 lg:p-6">
          {/* Header */}
          <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
            {/* <div className="text-center mb-6">
              <h1 className="text-2xl lg:text-3xl font-bold text-abiu-green-dark mb-2">Project Marketplace</h1>
              <p className="text-gray-600 text-sm lg:text-base">Browse real solar project requests and offers. Use the filters to narrow down your search.</p>
            </div> */}

            {/* Type Selection - Compact Switch */}
            <div className="mb-4">
              <div className="flex justify-center">
                <div className="bg-gray-100 rounded-xl p-1 inline-flex shadow-inner">
                  {typeOptions.map(opt => (
                    <button
                      key={opt}
                      className={`px-8 py-3 rounded-lg font-medium transition-all duration-300 text-base lg:text-lg min-w-[140px] relative ${
                        type === opt 
                          ? 'bg-abiu-green text-white shadow-lg transform scale-105' 
                          : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                      }`}
                      onClick={() => setType(opt)}
                    >
                      <span className="font-bold">
                        {opt === 'Request' ? 'For Sellers' : 'For Buyers'}
                      </span>
                      {type === opt && (
                        <div className="absolute -top-1 -right-1 w-3 h-3 bg-abiu-green rounded-full border-2 border-white"></div>
                      )}
                    </button>
                  ))}
                </div>
              </div>
              
              {/* Dynamic Description */}
              <div className="text-center mt-3">
                <p className="text-gray-600 text-sm lg:text-base">
                  {type === 'Request' 
                    ? 'Browse requests from buyers looking for solar products and services' 
                    : 'Browse offers from sellers providing solar products and services'
                  }
                </p>
              </div>
            </div>

            {/* Search Bar */}
            <div className="mb-4">
              <div className="relative">
                <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  placeholder="Search projects, location, or description..."
                  className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-abiu-green focus:border-abiu-green transition-colors"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Results Count */}
          <div className="mb-6">
            <div className="text-sm text-gray-600">
              {loading ? 'Loading...' : `${filtered.length} projects found`}
            </div>
          </div>

          {/* Project Cards */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
            {loading ? (
              <div className="col-span-2 md:col-span-3 lg:col-span-4 text-center text-gray-500 py-12">
                <div className="w-8 h-8 border-4 border-abiu-green border-t-transparent rounded-full animate-spin mx-auto mb-2"></div>
                Loading projects...
              </div>
            ) : filtered.length === 0 ? (
              <div className="col-span-2 md:col-span-3 lg:col-span-4 text-center text-gray-500 py-12">No projects found.</div>
            ) : null}
            {filtered.map((p, i) => (
              <div key={i} className="bg-white rounded-xl shadow p-0 flex flex-col overflow-hidden">
                <div className="relative">
                  {p.images && p.images.length > 0 ? (
                    <img src={p.images[0]} alt={p.title} className="w-full h-32 md:h-40 object-cover" />
                  ) : (
                    <div className="w-full h-32 md:h-40 bg-abiu-green"></div>
                  )}
                  <div className={`absolute top-2 left-2 md:top-3 md:left-3 px-2 md:px-3 py-1 rounded-full text-xs font-medium ${p.status === 'Open' ? (p.type === 'Request' ? 'bg-yellow-100 text-yellow-800' : 'bg-abiu-green-light text-abiu-green-dark') : 'bg-gray-200 text-gray-600'}`}>
                    {p.status === 'Open' ? (p.type === 'Request' ? 'Request' : 'Offer') : 'Closed'}
                  </div>
                  {p.images && p.images.length > 1 && (
                    <div className="absolute top-2 right-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded-full">
                      +{p.images.length - 1}
                    </div>
                  )}
                </div>
                <div className="p-3 md:p-4 flex-1 flex flex-col">
                  <div className="font-semibold text-sm md:text-base text-gray-900 mb-1 line-clamp-2">{p.title}</div>
                  <div className="flex items-center text-xs md:text-sm text-gray-600 mb-2">
                    <span role="img" aria-label="location" className="mr-1">📍</span> {p.location}
                  </div>
                  <div className="mb-2 text-gray-700 text-xs md:text-sm line-clamp-2">{p.description}</div>
                  {/* Seller reputation */}
                  {p.type === 'Offer' && p.user && p.user.reputation && (
                    <div className="mb-2">
                      <div className="flex items-center gap-1 text-yellow-500 text-xs">
                        <span>{'★'.repeat(Math.round(p.user.reputation.rating))}{'☆'.repeat(5 - Math.round(p.user.reputation.rating))}</span>
                        <span className="text-gray-600 ml-1">{p.user.reputation.rating.toFixed(1)} ({p.user.reputation.reviews})</span>
                      </div>
                    </div>
                  )}
                  {/* Info grid */}
                  <div className="grid grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-4">
                    <div className="bg-abiu-green-bg rounded-lg p-1 md:p-2 text-center">
                      <div className="text-xs text-gray-500">{p.type === 'Request' ? 'Budget' : 'Price'}</div>
                      <div className="font-semibold text-gray-800 text-xs md:text-sm">
                        {p.type === 'Request' ? (p.budget ? `₦${p.budget}` : 'Not specified') : (p.price ? `₦${p.price}` : 'Not specified')}
                      </div>
                    </div>
                    <div className="bg-abiu-green-bg rounded-lg p-1 md:p-2 text-center">
                      <div className="text-xs text-gray-500">Status</div>
                      <div className={`font-semibold text-xs md:text-sm ${p.status === 'Open' ? 'text-abiu-green-dark' : 'text-gray-400'}`}>{p.status}</div>
                    </div>
                  </div>
                  {/* Actions */}
                  <div className="mt-auto">
                    <button className="w-full bg-abiu-green text-white font-semibold py-2 md:py-3 px-3 md:px-4 rounded-lg hover:bg-abiu-green-dark transition text-xs md:text-sm" onClick={() => openModal('details', p)}>
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-10">
            <Link to="/" className="text-abiu-green hover:underline">&larr; Back to Dashboard</Link>
          </div>
        </div>
      </div>
      {/* Modals */}
      {modal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4">
          <div className="bg-white rounded-xl shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto relative animate-fadeIn">
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-abiu-green-dark text-2xl font-bold z-10"
              onClick={closeModal}
              aria-label="Close"
            >
              &times;
            </button>
            
            <div className="flex flex-col lg:flex-row">
              {/* Left Column - Project Details */}
              <div className="lg:w-1/2 p-6">
                <div className="font-bold text-2xl text-abiu-green-dark mb-4">{modal.project.title}</div>
                <div className="text-gray-700 mb-4 text-base leading-relaxed">{modal.project.description}</div>
                
                <div className="flex items-center text-sm text-gray-600 mb-4">
                  <span role="img" aria-label="location" className="mr-2 text-lg">📍</span> 
                  <span className="text-base">{modal.project.location}</span>
                </div>
                
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="bg-abiu-green-bg rounded-lg p-3 text-center">
                    <div className="text-sm text-gray-500 mb-1">{modal.project.type === 'Request' ? 'Budget' : 'Price'}</div>
                    <div className="font-semibold text-gray-800 text-lg">
                      {modal.project.type === 'Request' ? (modal.project.budget ? `₦${modal.project.budget}` : 'Not specified') : (modal.project.price ? `₦${modal.project.price}` : 'Not specified')}
                    </div>
                  </div>
                  <div className="bg-abiu-green-bg rounded-lg p-3 text-center">
                    <div className="text-sm text-gray-500 mb-1">Status</div>
                    <div className={`font-semibold text-lg ${modal.project.status === 'Open' ? 'text-abiu-green-dark' : 'text-gray-400'}`}>{modal.project.status}</div>
                  </div>
                </div>
                
                {/* Seller/Buyer info */}
                <div className="mb-6">
                  <div className="font-semibold text-abiu-green-dark mb-2 text-lg">{modal.project.type === 'Offer' ? 'Seller' : 'Buyer'}</div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-medium text-gray-800 text-base">
                      {modal.project.type === 'Request' 
                        ? (buyerProfile?.name || modal.project.buyerName || 'Unknown')
                        : (modal.project.sellerName || modal.project.user?.name || 'Unknown')
                      }
                    </span>
                    {modal.project.type === 'Offer' && modal.project.user?.reputation && (
                      <StarRating rating={modal.project.user.reputation.rating} reviews={modal.project.user.reputation.reviews} />
                    )}
                    {modal.project.type === 'Request' && !modal.project.user?.reputation && (
                      <span className="text-xs text-gray-400 ml-2">New</span>
                    )}
                  </div>
                </div>
              </div>
              
              {/* Right Column - Images and Contact */}
              <div className="lg:w-1/2 p-6 bg-gray-50 lg:bg-transparent">
                {/* Images */}
                {modal.project.images && modal.project.images.length > 0 ? (
                  <div className="mb-6">
                    <h3 className="font-semibold text-abiu-green-dark mb-3">Project Images</h3>
                    <div className="grid grid-cols-2 gap-3">
                      {modal.project.images.slice(0, 4).map((image, index) => (
                        <img 
                          key={index} 
                          src={image} 
                          alt={`${modal.project.title} ${index + 1}`} 
                          className="w-full h-32 object-cover rounded-lg shadow-sm"
                        />
                      ))}
                    </div>
                    {modal.project.images.length > 4 && (
                      <div className="text-center mt-2 text-sm text-gray-500">
                        +{modal.project.images.length - 4} more images
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="mb-6">
                    <h3 className="font-semibold text-abiu-green-dark mb-3">Project Images</h3>
                    <div className="w-full h-40 bg-abiu-green rounded-lg"></div>
                  </div>
                )}
                            {/* Contact Section */}
                <div className="mt-6 border-t pt-4">
                  <h3 className="font-semibold text-abiu-green-dark mb-4">Contact</h3>
                  
                  {/* Contact Icons */}
                  <div className="flex justify-center gap-4">
                    {contactLinks.map(link => {
                      const contactInfo = modal.project.type === 'Request' ? buyerProfile : sellerProfile;
                      const href = link.getHref(modal.project, contactInfo);
                      
                      // Only show links if we have the required contact info
                      if (link.label === 'Gmail' && !contactInfo?.email) return null;
                      if (link.label === 'WhatsApp' && !contactInfo?.phone) return null;
                      if (link.label === 'Instagram' && !contactInfo?.instagram) return null;
                      
                      // Define brand colors for each platform
                      const getBrandColors = (label) => {
                        switch (label) {
                          case 'Gmail':
                            return {
                              bg: 'bg-red-500',
                              border: 'border-red-600',
                              hover: 'hover:bg-red-600',
                              text: 'text-white'
                            };
                          case 'WhatsApp':
                            return {
                              bg: 'bg-green-500',
                              border: 'border-green-600',
                              hover: 'hover:bg-green-600',
                              text: 'text-white'
                            };
                          case 'Instagram':
                            return {
                              bg: 'bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500',
                              border: 'border-purple-600',
                              hover: 'hover:from-purple-600 hover:via-pink-600 hover:to-orange-600',
                              text: 'text-white'
                            };
                          default:
                            return {
                              bg: 'bg-abiu-green-light',
                              border: 'border-abiu-green',
                              hover: 'hover:bg-abiu-green',
                              text: 'text-abiu-green-dark'
                            };
                        }
                      };
                      
                      const colors = getBrandColors(link.label);
                      
                      return (
                        <a
                          key={link.label}
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`w-12 h-12 rounded-full ${colors.bg} ${colors.border} border-2 flex items-center justify-center ${colors.hover} ${colors.text} transition-all duration-300 transform hover:scale-110`}
                          title={link.label}
                        >
                          {link.icon}
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="p-6 border-t">
              <button className="w-full bg-abiu-green-light text-abiu-green-dark font-semibold py-3 rounded-lg hover:bg-abiu-green/30 transition" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Marketplace; 